import React from 'react';
import { Item } from '@radix-ui/react-dropdown-menu';

import { bemBlock } from '../../../modules/bem';

import './ActionsMenuAsChildItem.less';

const preventDefault = (event: Event) => {
  event.preventDefault();
};

const block = bemBlock('n-ActionsMenuAsChildItem');

export const ActionsMenuAsChildItem = React.forwardRef<
  React.ElementRef<'div'>,
  { children: React.ReactChild }
>(function ActionsMenuAsChildItem({ children }, ref) {
  return (
    <Item asChild onSelect={preventDefault} ref={ref} className={block()}>
      {children}
    </Item>
  );
});
